import { takeEvery, call, put } from 'redux-saga/effects';

import { feedbackMessageHide, feedbackMessageShow } from 'src/app/redux/actions/feedbackMessage';
import { SEND_ACTIVATION_EMAIL, sentActivationEmail } from 'src/app/redux/actions/registration/registration';
import registrationApi from 'src/app/api/registrationApi';
import { apiCommonError } from 'src/app/redux/actions/apiError';
import alerts from 'src/app/alerts.json';


function sendActivationEmail(request, messageTemplate) {
  return function* sendActivationEmailGenerator({ payload }) {
    const { userId } = payload;

    yield put(feedbackMessageHide());

    function* onSuccess(response) {
      yield put(sentActivationEmail());
      yield put(feedbackMessageShow(messageTemplate));

      return response;
    }
    function* onError({ response }) {
      yield put(sentActivationEmail());
      yield put(apiCommonError(response));
    }

    const sendActivationEmailWithDispatchers = yield request(userId)
      .then(onSuccess)
      .catch(onError);

    yield call(() => sendActivationEmailWithDispatchers);
  };
}

export default [
  takeEvery(
    SEND_ACTIVATION_EMAIL,
    sendActivationEmail(registrationApi.sendActivationEmail, alerts.resentActivationLink)
  )
];
